<script>
  export let article;
</script>

<div class="reading_material_grid_slot">
  <img alt="" src={article.thumbnail} style="width: 100%; object-fit: cover" />
  <p
    class="body_text"
    style="color: white; text-decoration: underline; margin: 0; margin-bottom: 5px; margin-top: 10px;"
  >
    {article.title}
  </p>
  <p
    class="body_text no_hover"
    style="text-decoration: none !important; margin: 0"
  >
    {article.subtitle}
  </p>
</div>

<style>
  .reading_material_grid_slot {
    width: 100%;
    object-fit: cover;
  }

  .no_hover {
    color: white !important;
    text-decoration: none;
  }
  .no_hover:hover {
    color: white !important;
    text-decoration: none;
  }

  .no_hover:visited {
    color: white !important;
    text-decoration: none;
  }
</style>
